import React from "react";
import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolioNew/portfolioSlice";

import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

import numberFormatter from "utils/numberFormatter";
import {
    selectIsLoading,
    selectHasErrors,
    selectChainIndependantSplit
} from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";

const ChainIndependentSplit = () => {
    const colourPalette = useColourPalette();
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const storeCounts = useAppSelector(selectChainIndependantSplit);
    const selectedStoreCount = storeCounts.selectedStore.totalStoreCount;
    const selectedChainCount = storeCounts.selectedStore.chainCount;
    const comparatorStoreCount = storeCounts.comparator.totalStoreCount;
    const comparatorIndependCount = storeCounts.comparator.chainCount;
    const differencePositiveSign = storeCounts.difference > 0 ? "+" : "";

    const label = `Chain : Independent split within your ${selectedStore?.name} store's retail zone`;

    return (
        <Box width="100%" height="100%" data-cy="chain-independent-split-in-retail-zone">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {numberFormatter.toRatio(selectedChainCount / selectedStoreCount)}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {numberFormatter.toRatio(comparatorIndependCount / comparatorStoreCount)}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${selectedComparator?.name} `}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{storeCounts.difference}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default ChainIndependentSplit;
